<template>
    <!-- 已收集个人信息清单（华为规范版） -->
    <div class="hw_info_table">
        <p class="intro">
            在新的服务需求及业务功能变更时，我们可能会调整我们收集信息的范围，
            并及时在本说明中向您说明情况。
        </p>

        <table>
            <thead>
                <tr>
                    <th>信息名称</th>
                    <th>信息类型</th>
                    <th>使用目的</th>
                    <th>使用场景</th>
                </tr>
            </thead>
            <tbody>
                <!-- 个人基本资料 -->
                <tr>
                    <td>昵称</td>
                    <td>个人基本资料</td>
                    <td>用于用户身份展示</td>
                    <td>用户注册、登录后展示</td>
                </tr>
                <tr>
                    <td>头像</td>
                    <td>个人基本资料</td>
                    <td>用于用户身份展示</td>
                    <td>用户注册、登录后展示</td>
                </tr>
                <tr>
                    <td>出生日期</td>
                    <td>个人基本资料</td>
                    <td>用于完善用户资料</td>
                    <td>用户填写个人资料时</td>
                </tr>
                <tr>
                    <td>性别</td>
                    <td>个人基本资料</td>
                    <td>用于完善用户资料</td>
                    <td>用户填写个人资料时</td>
                </tr>
                <tr>
                    <td>联系方式</td>
                    <td>个人基本资料</td>
                    <td>用于账号验证及联系用户</td>
                    <td>注册、找回账号或客服沟通时</td>
                </tr>

                <!-- 设备信息 -->
                <tr>
                    <td>设备型号</td>
                    <td>设备信息</td>
                    <td>用于设备适配</td>
                    <td>应用启动及运行过程中</td>
                </tr>
                <tr>
                    <td>操作系统版本</td>
                    <td>设备信息</td>
                    <td>用于兼容性适配</td>
                    <td>应用启动及运行过程中</td>
                </tr>
                <tr>
                    <td>设备标识符（OAID / AAID / ODID）</td>
                    <td>设备信息</td>
                    <td>用于统计分析及异常识别</td>
                    <td>应用启动及统计分析时</td>
                </tr>

                <!-- 应用使用信息 -->
                <tr>
                    <td>应用版本号</td>
                    <td>应用使用信息</td>
                    <td>用于问题排查和统计分析</td>
                    <td>应用运行过程中</td>
                </tr>
                <tr>
                    <td>应用运行状态</td>
                    <td>应用使用信息</td>
                    <td>用于优化应用性能</td>
                    <td>应用运行过程中</td>
                </tr>

                <!-- 用户主动上传 -->
                <tr>
                    <td>用户上传的文字内容</td>
                    <td>您主动上传的数据</td>
                    <td>用于内容展示</td>
                    <td>用户发布内容时</td>
                </tr>
                <tr>
                    <td>用户上传的图片</td>
                    <td>您主动上传的数据</td>
                    <td>用于内容展示</td>
                    <td>用户发布内容时</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import jsbridg from "../../utils/jsbridg"
export default {
    name: 'hw_info_table',
    mounted () {
        document.getElementsByTagName('title')[0].innerHTML = '已收集个人信息清单';
        jsbridg.setTitle('已收集个人信息清单')
    }
}

</script>
<style lang="less" scoped>
.hw_info_table {
    padding: 16px;
    font-size: 13px;
    color: #333;

    .intro {
        margin-bottom: 12px;
        color: #666;
        line-height: 22px;
    }

    table {
        width: 100%;
        border-collapse: collapse;
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
    }

    th, td {
        border: 1px solid #e6e6e6;
        padding: 8px;
        text-align: left;
        vertical-align: top;
        line-height: 20px;
    }

    th {
        background: #f5f6f8;
        font-weight: 600;
        color: #171717;
    }
}
</style>
